import store from "../store";
import { app, firestore } from "../lib/firebase";
import * as introJs from "intro.js";
const intro = introJs();

intro.setOption("nextLabel", "Siguiente");
intro.setOption("prevLabel", "Anterior");
intro.setOption("skipLabel", "Saltar");
intro.setOption("doneLabel", "Terminar");
intro.setOption("tooltipClass", "tooltipClass");
intro.setOption("overlayOpacity", 0.9);

/**
 * Add an element to the intro.
 * @param {HTMLElement} element
 * @param {String} introStr
 */
export const addStep = ({ element, introStr, step }) => {
  intro.addStep({
    element,
    intro: introStr,
    step
  });
};

/**
 * Start the intro.
 */
export const start = () => {
  if (!store.state.project.intro) {
    intro.start();
  }
};

intro.oncomplete(async () => {
  if (!store.state.project.intro) {
    await (await firestore())
      .collection("projects")
      .doc(store.state.user.uid)
      .update({
        intro: true
      });
  }
});
